import type { ReactNode } from 'react'
import cn from 'classnames'

import {
  CollapseToSingleColumnBreakpoints,
  TwoColumnGapType,
  TwoColumnProportion,
} from '../../../lib/types/section-two-column'

import styles from './two-column.module.scss'
import { TypeVerticalAlignment } from '@lib/types/alignment'

const alignmentStyleMap = {
  top: styles.alignTop,
  bottom: styles.alignBottom,
  default: '',
}

const getAlignmentStyle = (alignment: TypeVerticalAlignment = 'default') => {
  return alignmentStyleMap[alignment] || ''
}

interface TwoColumnLayoutProps {
  className?: string
  leftContent: ReactNode
  rightContent: ReactNode
  columnsProportion: TwoColumnProportion
  gutterGap?: TwoColumnGapType
  reverseOrderWhenVertical?: boolean
  collapseToSingleColumnBreakpoint?: CollapseToSingleColumnBreakpoints
  leftColumnVerticalAlignment?: TypeVerticalAlignment
  rightColumnVerticalAlignment?: TypeVerticalAlignment
}

export const TwoColumnLayout = (props: TwoColumnLayoutProps) => {
  const {
    gutterGap,
    collapseToSingleColumnBreakpoint = CollapseToSingleColumnBreakpoints.small,
    reverseOrderWhenVertical,
    columnsProportion,
    leftContent,
    rightContent,
    className,
    leftColumnVerticalAlignment,
    rightColumnVerticalAlignment,
  } = props

  const leftColumnVerticalStyle = getAlignmentStyle(leftColumnVerticalAlignment)
  const rightColumnVerticalStyle = getAlignmentStyle(rightColumnVerticalAlignment)

  return (
    <div
      className={cn(styles.container, className, {
        [styles[`${collapseToSingleColumnBreakpoint}CollapseToSingleColumn`]]: collapseToSingleColumnBreakpoint,
        [styles[`gutterGap${gutterGap}`]]: gutterGap,
        [styles.reverseInSingleColumn]: reverseOrderWhenVertical,
      })}
    >
      <div
        data-aspect-ratio={columnsProportion}
        className={cn(styles.leftColumnContent, leftColumnVerticalStyle, {
          [styles[`${collapseToSingleColumnBreakpoint}CollapseToSingleColumn`]]: collapseToSingleColumnBreakpoint,
        })}
      >
        {leftContent}
      </div>
      <div
        data-aspect-ratio={columnsProportion}
        className={cn(styles.rightColumnContent, rightColumnVerticalStyle, {
          [styles[`${collapseToSingleColumnBreakpoint}CollapseToSingleColumn`]]: collapseToSingleColumnBreakpoint,
        })}
      >
        {rightContent}
      </div>
    </div>
  )
}
